module.exports = __webpack_public_path__ + "static/media/instruction_calf.95cdc894.webp";